module.exports = __webpack_public_path__ + "img/skypostal.e4c9eb15.png";